import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import BlocksRenderer from "../components/blocks-renderer";
import Seo from "../components/seo";
import Hero from "../components/hero";
import Navigation from "../components/navigation";
import Footer from "../components/footer";
import Bgimg from "../images/dynamicpage-img.jpg";

const Page = ({ data, pageContext }) => {
  const page = data.strapiPage;
  let topMenu = data.allStrapiTopMenu.edges[0].node;
  //navigation is passed to pagecontext during build
  return (
    <Layout>
      {page && page.Hero ? (
        <Hero hero={page.Hero} topMenu={topMenu} mainMenu={pageContext.nav} />
      ) : (
        <div
          className={`h-screen bg-cover bg-no-repeat`}
          style={{ backgroundImage: `url(${Bgimg})` }}
        >
          <Navigation topMenu={topMenu} mainMenu={pageContext.nav} />
        </div>
      )}
      <h1 className="lg:text-6xl text-5xl  font-poppinsbold mx-auto max-w-screen-xl xxl:max-w-screen-3xl text-center p-5 lg:p-0">
        {page?.Title}
      </h1>
      <BlocksRenderer blocks={page.DynZone || []} />
      <Footer />
    </Layout>
  );
};

export const pageQuery = graphql`
  query ($id: String) {
    strapiPage(id: { eq: $id }) {
      id
      Title
      DynZone {
        ...Blocks
      }
      Hero {
        ShowPanelLeft
        Title
        Text {
          data {
            Text
          }
        }
        Button {
          Label
          Link
          ShowButton
        }
        Media {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      seo {
        metaTitle
        metaDescription
        metaImage {
          localFile {
            url
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        metaSocial {
          socialNetwork
          title
          description
        }
        keywords
        metaRobots
        canonicalURL
      }
    }

    allStrapiTopMenu {
      edges {
        node {
          TopMenuItem {
            Title
            Url
            Icon {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const Head = ({ data }) => {
  const page = data.strapiPage;
  return (
    <>
      <html lang="en" />
      <Seo seo={page.seo} />
    </>
  );
};

export default Page;
